import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LOGO_URL, HERO_BG_URL } from "../lib/config";

export default function MaintenancePage({ message }) {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden px-5" data-testid="maintenance-page">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG_URL})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-fp-bg/80 via-fp-bg/85 to-fp-bg" />
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="absolute inset-0 radial-glow" />

      <div className="relative text-center max-w-2xl">
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="relative inline-block"
        >
          <div className="absolute inset-0 rounded-full bg-fp-cyan/20 blur-[80px] animate-pulse" />
          <img
            src={LOGO_URL}
            alt="Fanta Partenope"
            className="relative w-56 md:w-72 mx-auto animate-float animate-pulse-glow"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="mt-12"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-fp-cyan/30 bg-fp-cyan/5 backdrop-blur-sm mb-6">
            <span className="w-2 h-2 rounded-full bg-fp-cyan animate-pulse" />
            <span className="text-fp-cyan text-xs font-heading font-semibold tracking-[0.3em] uppercase">
              Lavori in corso
            </span>
          </div>

          <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tight">
            <span className="silver-gradient block">Sito in</span>
            <span className="cyan-gradient block cyan-text-glow">manutenzione</span>
          </h1>

          <p className="mt-6 text-white/70 text-base md:text-lg max-w-md mx-auto leading-relaxed" data-testid="maintenance-message">
            {message || "Torneremo a breve con grandi novità..."}
          </p>

          <div className="mt-10 flex items-center justify-center gap-2">
            <span className="w-2 h-2 rounded-full bg-fp-cyan animate-bounce" style={{ animationDelay: "0ms" }} />
            <span className="w-2 h-2 rounded-full bg-fp-cyan animate-bounce" style={{ animationDelay: "150ms" }} />
            <span className="w-2 h-2 rounded-full bg-fp-cyan animate-bounce" style={{ animationDelay: "300ms" }} />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="mt-16 text-[10px] tracking-[0.4em] uppercase text-white/30 font-heading font-semibold"
        >
          Fanta Partenope · Edizione 2026/2027
        </motion.div>
      </div>

      {/* Hidden admin access — clickable but visually subtle */}
      <Link
        to="/admin/login"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 maintenance-access text-[10px] tracking-[0.4em] uppercase text-white/30 hover:text-fp-cyan font-heading font-semibold no-underline"
        data-testid="maintenance-admin-link"
      >
        Fantapartenope
      </Link>
    </div>
  );
}
